import rfdc from 'rfdc';
import isEqual from 'fast-deep-equal';
const clone = rfdc();
/**
 * Check if workflow draft has actual changes, ignoring specified fields
 *
 * @param workflow - The workflow object containing draft and published versions
 * @param ignoreFields - Array of field names to ignore when comparing (default: ['testResult'])
 * @returns true if there are actual differences (excluding ignored fields), false otherwise
 */
export function hasWorkflowDraftChanges(workflow, ignoreFields = ['testResult']) {
    // If no draft exists, no changes
    if (!workflow.draft) {
        return false;
    }
    // If no published version, any draft is considered a change
    if (!workflow.nodes || !workflow.edges) {
        return !!(workflow.draft.nodes || workflow.draft.edges);
    }
    // Deep clone both objects to avoid mutation
    const draftCleaned = clone({
        nodes: workflow.draft.nodes || [],
        edges: workflow.draft.edges || [],
    });
    const publishedCleaned = clone({
        nodes: workflow.nodes || [],
        edges: workflow.edges || [],
    });
    const cleanNodes = (nodes) => {
        if (!nodes)
            return [];
        return nodes.map((node) => {
            if (node.data) {
                ignoreFields.forEach((field) => {
                    if (node.data[field] !== undefined) {
                        delete node.data[field];
                    }
                });
            }
            return node;
        });
    };
    draftCleaned.nodes = cleanNodes(draftCleaned.nodes);
    publishedCleaned.nodes = cleanNodes(publishedCleaned.nodes);
    // Compare the cleaned objects
    return !isEqual(draftCleaned, publishedCleaned);
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZHJhZnRVdGlscy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9lZS9saWIvd29ya2Zsb3cvZHJhZnRVdGlscy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLElBQUksTUFBTSxNQUFNLENBQUM7QUFDeEIsT0FBTyxPQUFPLE1BQU0saUJBQWlCLENBQUM7QUFJdEMsTUFBTSxLQUFLLEdBQUcsSUFBSSxFQUFFLENBQUM7QUFFckI7Ozs7OztHQU1HO0FBQ0gsTUFBTSxVQUFVLHVCQUF1QixDQUNyQyxRQUFzQixFQUN0QixlQUF5QixDQUFDLFlBQVksQ0FBQztJQUV2QyxpQ0FBaUM7SUFDakMsSUFBSSxDQUFDLFFBQVEsQ0FBQyxLQUFLLEVBQUUsQ0FBQztRQUNwQixPQUFPLEtBQUssQ0FBQztJQUNmLENBQUM7SUFFRCw0REFBNEQ7SUFDNUQsSUFBSSxDQUFDLFFBQVEsQ0FBQyxLQUFLLElBQUksQ0FBQyxRQUFRLENBQUMsS0FBSyxFQUFFLENBQUM7UUFDdkMsT0FBTyxDQUFDLENBQUMsQ0FBQyxRQUFRLENBQUMsS0FBSyxDQUFDLEtBQUssSUFBSSxRQUFRLENBQUMsS0FBSyxDQUFDLEtBQUssQ0FBQyxDQUFDO0lBQzFELENBQUM7SUFFRCw0Q0FBNEM7SUFDNUMsTUFBTSxZQUFZLEdBQUcsS0FBSyxDQUFDO1FBQ3pCLEtBQUssRUFBRSxRQUFRLENBQUMsS0FBSyxDQUFDLEtBQUssSUFBSSxFQUFFO1FBQ2pDLEtBQUssRUFBRSxRQUFRLENBQUMsS0FBSyxDQUFDLEtBQUssSUFBSSxFQUFFO0tBQ2xDLENBQUMsQ0FBQztJQUNILE1BQU0sZ0JBQWdCLEdBQUcsS0FBSyxDQUFDO1FBQzdCLEtBQUssRUFBRSxRQUFRLENBQUMsS0FBSyxJQUFJLEVBQUU7UUFDM0IsS0FBSyxFQUFFLFFBQVEsQ0FBQyxLQUFLLElBQUksRUFBRTtLQUM1QixDQUFDLENBQUM7SUFFSCxNQUFNLFVBQVUsR0FBRyxDQUFDLEtBQWlDLEVBQUUsRUFBRTtRQUN2RCxJQUFJLENBQUMsS0FBSztZQUFFLE9BQU8sRUFBRSxDQUFDO1FBQ3RCLE9BQU8sS0FBSyxDQUFDLEdBQUcsQ0FBQyxDQUFDLElBQUksRUFBRSxFQUFFO1lBQ3hCLElBQUksSUFBSSxDQUFDLElBQUksRUFBRSxDQUFDO2dCQUNkLFlBQVksQ0FBQyxPQUFPLENBQUMsQ0FBQyxLQUFLLEVBQUUsRUFBRTtvQkFDN0IsSUFBSSxJQUFJLENBQUMsSUFBSSxDQUFDLEtBQUssQ0FBQyxLQUFLLFNBQVMsRUFBRSxDQUFDO3dCQUNuQyxPQUFPLElBQUksQ0FBQyxJQUFJLENBQUMsS0FBSyxDQUFDLENBQUM7b0JBQzFCLENBQUM7Z0JBQ0gsQ0FBQyxDQUFDLENBQUM7WUFDTCxDQUFDO1lBQ0QsT0FBTyxJQUFJLENBQUM7UUFDZCxDQUFDLENBQUMsQ0FBQztJQUNMLENBQUMsQ0FBQztJQUVGLFlBQVksQ0FBQyxLQUFLLEdBQUcsVUFBVSxDQUFDLFlBQVksQ0FBQyxLQUFtQyxDQUFDLENBQUM7SUFDbEYsZ0JBQWdCLENBQUMsS0FBSyxHQUFHLFVBQVUsQ0FBQyxnQkFBZ0IsQ0FBQyxLQUFtQyxDQUFDLENBQUM7SUFFMUYsOEJBQThCO0lBQzlCLE9BQU8sQ0FBQyxPQUFPLENBQUMsWUFBWSxFQUFFLGdCQUFnQixDQUFDLENBQUM7QUFDbEQsQ0FBQyJ9